import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const AngleDown = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9 9.2C16.5 8.8 15.9 8.8 15.5 9.2L12 12.7L8.5 9.2C8.1 8.8 7.5 8.8 7.1 9.2C6.7 9.6 6.7 10.2 7.1 10.6L11.3 14.8C11.5 15 11.7 15.1 12 15.1C12.3 15.1 12.5 15 12.7 14.8L16.9 10.6C17.3 10.2 17.3 9.6 16.9 9.2Z"
      fill="currentColor"
    />
  </svg>
)

export default AngleDown
